import { useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import {
  Square,
  SquareCheckBig,
  Printer,
  ArrowLeftCircle,
  PrinterIcon,
} from "lucide-react";
import { format } from "date-fns";
import { useNavigate, Link } from "react-router-dom";

const RFDetail = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    const email = storedUser?.email;

    fetch(
      `${process.env.REACT_APP_BASE_URL}api/users/search?email=${encodeURIComponent(email)}`,
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          setUser(data.data);
          console.error(data.data);
        } else {
          console.error(data.message);
        }
      })
      .catch((err) => console.error(err));
  }, []);

  const storedUser = JSON.parse(localStorage.getItem("user"));
  const email = storedUser?.email;

  const now = new Date();
  const offset = 7 * 60; // +7 jam dalam menit
  const localTime = new Date(now.getTime() + offset * 60000);
  const formattedNow = localTime.toISOString().slice(0, 19).replace("T", " ");

  const [formData, setFormData] = useState({
    read: "read",
    printed_by: email,
    date_of_printed: formattedNow,
  });

  const handlePrint = () => {
    fetch(`${process.env.REACT_APP_BASE_URL}api/rf/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    window.print();
  };
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [note, setNote] = useState([]);
  const [invoiceimg, setInvoiceimg] = useState([]);

  useEffect(() => {
    const fetchAll = async () => {
      try {
        // Fetch rf/$id
        const resRF = await fetch(
          `${process.env.REACT_APP_BASE_URL}api/rf/${id}`,
        );
        if (!resRF.ok) throw new Error(`HTTP error! status: ${resRF.status}`);

        const jsonRF = await resRF.json();
        const noteValue = jsonRF.data?.note || "";
        const noteInputDateTime = jsonRF.data?.input_date || "";
        const noteInputDate = noteInputDateTime
          ? new Date(noteInputDateTime).toISOString().split("T")[0]
          : "";

        setData(jsonRF.data);
        setLoading(false);

        // Fetch attachment/search
        const resAttach = await fetch(
          `${process.env.REACT_APP_BASE_URL}/api/attachment/search?query=${id}`,
        );
        if (!resAttach.ok)
          throw new Error(`HTTP error! status: ${resAttach.status}`);

        const invoiceimg = await resAttach.json();
        const list = Array.isArray(invoiceimg)
          ? invoiceimg
          : invoiceimg.data || [];

        if (list.length === 0 && noteValue) {
          // Fetch attachment/note jika list kosong
          const resNote = await fetch(
            `${process.env.REACT_APP_BASE_URL}/api/attachment/note?query=${encodeURIComponent(noteValue)}&input_date=${encodeURIComponent(noteInputDate)}`,
          );
          if (!resNote.ok)
            throw new Error(`HTTP error! status: ${resNote.status}`);
          const invoiceimg2 = await resNote.json();
          const list2 = Array.isArray(invoiceimg2)
            ? invoiceimg2
            : invoiceimg2.data || [];
          setInvoiceimg(list2);
        } else {
          setInvoiceimg(list);
        }
      } catch (err) {
        console.error("Fetch error:", err);
        setLoading(false);
      }
    };

    fetchAll();
  }, [id]);

  useEffect(() => {
    if (loading) {
      document.title = "Loading... ";
    } else if (data?.note) {
      document.title = `${data.note}`;
    } else if (Array.isArray(note) && note.length > 0) {
      document.title = `${note[0].note}`;
    } else {
      document.title = "Dashboard";
    }
  }, [loading, data, note]);

  useEffect(() => {
    const fetchNote = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_BASE_URL}/api/note/search?query=${id}`,
        );

        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }

        const note = await res.json();
        const list = Array.isArray(note) ? note : note.data || [];
        // filter data dengan total > 0
        const filteredList = list.filter((item) => item.total > 0);

        console.log("Data Note:", list);
        setNote(filteredList);
      } catch (err) {
        console.error("Gagal mengambil data note:", err);
      }
    };
    fetchNote();
  }, []);

  const indexTarget = 1;

  const totalSum = Array.isArray(note)
    ? note.reduce((acc, curr) => acc + Number(curr.total || 0), 0)
    : 0;

  const totalDpp = Array.isArray(note)
    ? note.reduce((acc, curr) => acc + Number(curr.dpp || 0), 0)
    : 0;

  if (loading) return <div className="text-center mt-10">Loading...</div>;
  if (!data)
    return (
      <div className="text-center mt-10 text-red-500">Data tidak ditemukan</div>
    );

  const chunkArray = (arr, size) =>
    arr.reduce(
      (acc, _, i) => (i % size ? acc : [...acc, arr.slice(i, i + size)]),
      [],
    );

  return (
    <div className="max-w-full mx-auto p-2">
      <div className="gap-2 grid grid-cols-1 md:grid-cols-[1fr_auto] items-center">
        {/* LEFT (flexible) */}
        <div className="min-w-0">
          <h1 className="text-2xl font-bold mb-4 truncate">
            {!data.note ? (
              Array.isArray(note) &&
              note
                .slice(0, 1)
                .map((a, idx) => <label key={idx}>{a.note}</label>)
            ) : (
              <label>{data.note}</label>
            )}
          </h1>
        </div>
        {/* RIGHT (auto width, always right) */}
        <div className="flex justify-end">
          <div className="flex flex-row gap-2 items-center">
            <button
              onClick={handlePrint}
              className="py-2 px-4 bg-gradient-to-bl from-green-600 to-green-900 text-white rounded-2xl shadow-lg hover:scale-110 transition flex items-center"
            >
              <PrinterIcon className="mr-2" /> Print Ajuan
            </button>
            <Link to="/" className="flex items-center">
              <button className="bg-gradient-to-br from-black via-gray-900 to-gray-700 text-white shadow-lg hover:scale-110 transition flex items-center py-2 px-4 rounded-2xl">
                <ArrowLeftCircle className="mr-2" /> Kembali ke List Ajuan
              </button>
            </Link>
          </div>
        </div>
      </div>
      <div className="max-w-full mx-auto mt-2 p-4 bg-white rounded shadow">
        <div className="absolute top-40 right-8 overflow-hidden w-48 h-48 print:hidden">
          <span
            className={`absolute top-[40px] left-[2px] w-[240px] h-[40px] ${data.trf === "0" ? "bg-red-500" : "bg-green-500"} text-white text-center px-2 py-2 font-bold rotate-[45deg] shadow-xl print:hidden`}
          >
            {data.trf === "0" ? "BELUM TRANSFER" : "SUDAH TRANSFER"}
          </span>
        </div>
        <div id="print-area">
          <div className="flex flex-row text-xs mb-2">
            <div className="w-full w-1/4 px-1">
              <img
                src="/riiv3/images/rii-new.png"
                alt="Logo"
                className="h-32"
              />
            </div>
            <div className="w-full w-1/4 gap-2 px-2 flex flex-col">
              <label>&nbsp;</label>
              <div className="flex items-center gap-2">
                {data.type === "um" ? (
                  <SquareCheckBig size={16} />
                ) : (
                  <Square size={16} />
                )}
                Permintaan Uang Muka
              </div>
              <div className="flex items-center gap-2">
                {data.type === "reimburse" ? (
                  <SquareCheckBig size={16} />
                ) : (
                  <Square size={16} />
                )}{" "}
                Reimbursement
              </div>
              <div className="flex items-center gap-2">
                {data.type === "dp" ? (
                  <SquareCheckBig size={16} />
                ) : (
                  <Square size={16} />
                )}{" "}
                DP ke vendor/talent
              </div>
              <div className="flex items-center gap-2">
                {data.type === "pelunasan" ? (
                  <SquareCheckBig size={16} />
                ) : (
                  <Square size={16} />
                )}{" "}
                Pelunasan ke vendor/talent
              </div>
            </div>
            <div className="w-full w-1/4 px-2">
              Transfer Bank
              <table className="min-w-full">
                <tr>
                  <td className="text-left font-medium ">Nama Bank</td>
                  <td className="text-left font-medium">:</td>
                  <td className="text-left font-medium text-gray-700">
                    {data.bank}
                  </td>
                </tr>
                <tr>
                  <td className="text-left font-medium ">No. rekening</td>
                  <td className="text-left font-medium">:</td>
                  <td className="text-left font-medium text-gray-700">
                    {data.no_rek}
                  </td>
                </tr>
                <tr>
                  <td className="text-left font-medium ">Atas Nama</td>
                  <td className="text-leftfont-medium">:</td>
                  <td className="text-left font-medium text-gray-700">
                    {data.atas_nama}
                  </td>
                </tr>
                <tr>
                  <td className="text-left font-medium ">Cabang</td>
                  <td className="text-left font-medium">:</td>
                  <td className="text-left font-medium text-gray-700">
                    {data.cabang}
                  </td>
                </tr>
                <tr>
                  <td className="text-left font-medium ">Tgl Request bayar</td>
                  <td className="text-left font-medium">:</td>
                  <td className="text-left font-medium text-gray-700">
                    {format(new Date(data.request_date), "dd MMM yyyy")}
                  </td>
                </tr>
              </table>
            </div>
            <div className="w-full w-1/4 px-2 text-xs">
              &nbsp;
              <table className="min-w-full">
                <tr>
                  <td className="text-left font-medium ">Tgl Pengajuan</td>
                  <td className="text-left font-medium text-gray-700">
                    : {format(new Date(data.tanggal_final), "dd MMM yyyy")}
                  </td>
                </tr>
                <tr>
                  <td className="text-left font-medium ">Nama PIC</td>
                  <td className="text-left font-medium text-gray-700">
                    : {data.pic}
                  </td>
                </tr>
                <tr>
                  <td className="text-left font-medium ">Nama Event</td>
                  <td className="text-left text-sm font-medium text-gray-700">
                    : {data.event}
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <label className="font-bold text-xs">Form Pengajuan Pembayaran</label>
          <table className="min-w-full text-xs border border-black/100 mb-2 border-collapse">
            <thead className="bg-gray-100">
              <tr>
                <th className="border border-black px-2 py-2 text-center font-bold">
                  No
                </th>
                <th className="border border-black px-2 py-2 text-center font-bold ">
                  Keterangan
                </th>
                <th className="border border-black px-2 py-2 text-center font-bold">
                  Nama Vendor/Talent
                </th>
                <th className="border border-black px-2 py-2 text-center font-bold">
                  Nilai
                </th>
              </tr>
            </thead>
            <tbody className="bg-white">
              {!data.note ? (
                Array.isArray(note) &&
                note.map((a, idx) => (
                  <>
                    <tr>
                      <td className="border border-black px-2 py-1 text-center">
                        {idx + 1}
                      </td>
                      <td className="border border-black px-2 py-1">
                        {a.note}
                      </td>
                      <td className="border border-black px-2 py-1 text-center">
                        {data.vendor}
                      </td>
                      <td className="border border-black px-2 py-1 text-right">
                        {new Intl.NumberFormat("id-ID", {
                          style: "currency",
                          currency: "IDR",
                          minimumFractionDigits: 0,
                        }).format(a.dpp && a.dpp > 0 ? a.dpp : a.total)}
                      </td>
                    </tr>
                    {/* <tr>
                                    <td className="border border-black px-2 py-1 text-center"></td>
                                    <td className="border border-black px-2 py-1"></td>
                                    <td className="border border-black px-2 py-1 text-right font-bold" >PPN 11%</td>
                                    <td className="border border-black px-2 py-1 text-right">
                                        {new Intl.NumberFormat('id-ID', {
                                        style: 'currency',
                                        currency: 'IDR',
                                        minimumFractionDigits: 0,
                                        }).format(a.ppn)}
                                    </td>
                                </tr> */}
                  </>
                ))
              ) : (
                <tr>
                  <td className="border border-black px-2 py-2 border border-black text-center">
                    1
                  </td>
                  <td className="border border-black px-2 py-2 border border-black ">
                    {data.note}
                  </td>
                  <td className="border border-black px-2 py-2 border border-black ">
                    {data.vendor}
                  </td>
                  <td className="border border-black px-2 py-2 text-right">
                    {new Intl.NumberFormat("id-ID", {
                      style: "currency",
                      currency: "IDR",
                      minimumFractionDigits: 0,
                    }).format(data.total)}
                  </td>
                </tr>
              )}
              {!data.note2 ? (
                ""
              ) : (
                <tr>
                  <td className="border border-black px-2 py-2 text-center">
                    2
                  </td>
                  <td className="border border-black px-2 py-2">
                    {data.note2}
                  </td>
                  <td className="border border-black px-2 py-2">
                    {data.vendor}
                  </td>
                  <td className="border border-black px-2 py-2 text-right">
                    {new Intl.NumberFormat("id-ID", {
                      style: "currency",
                      currency: "IDR",
                      minimumFractionDigits: 0,
                    }).format(data.total2)}
                  </td>
                </tr>
              )}
              {!data.note3 ? (
                ""
              ) : (
                <tr>
                  <td className="border border-black px-2 py-2 text-center">
                    3
                  </td>
                  <td className="border border-black px-2 py-2">
                    {data.note3}
                  </td>
                  <td className="border border-black px-2 py-2">
                    {data.vendor}
                  </td>
                  <td className="border border-black px-2 py-2 text-right">
                    {new Intl.NumberFormat("id-ID", {
                      style: "currency",
                      currency: "IDR",
                      minimumFractionDigits: 0,
                    }).format(data.total3)}
                  </td>
                </tr>
              )}
              {!data.note4 ? (
                ""
              ) : (
                <tr>
                  <td className="border border-black px-2 py-2 text-center">
                    4
                  </td>
                  <td className="border border-black px-2 py-2">
                    {data.note4}
                  </td>
                  <td className="border border-black px-2 py-2">
                    {data.vendor}
                  </td>
                  <td className="border border-black px-2 py-2 text-right">
                    {new Intl.NumberFormat("id-ID", {
                      style: "currency",
                      currency: "IDR",
                      minimumFractionDigits: 0,
                    }).format(data.total4)}
                  </td>
                </tr>
              )}
              {!data.note5 ? (
                ""
              ) : (
                <tr>
                  <td className="border border-black px-2 py-2 text-center">
                    5
                  </td>
                  <td className="border border-black px-2 py-2">
                    {data.note5}
                  </td>
                  <td className="border border-black px-2 py-2">
                    {data.vendor}
                  </td>
                  <td className="border border-black px-2 py-2 text-right">
                    {new Intl.NumberFormat("id-ID", {
                      style: "currency",
                      currency: "IDR",
                      minimumFractionDigits: 0,
                    }).format(data.total5)}
                  </td>
                </tr>
              )}

              {!data.note ? (
                <tr>
                  <td className="border border-black px-2 py-1 text-center"></td>
                  <td className="border border-black px-2 py-1"></td>
                  <td className="border border-black px-2 py-1 font-bold text-right text-sm">
                    Total
                  </td>
                  <td className="border border-black px-2 py-1 font-bold text-right text-sm">
                    {new Intl.NumberFormat("id-ID", {
                      style: "currency",
                      currency: "IDR",
                      minimumFractionDigits: 0,
                    }).format(totalSum)}
                  </td>
                </tr>
              ) : (
                <tr>
                  <td className="border border-black px-2 py-1"></td>
                  <td className="border border-black px-2 py-1"></td>
                  <td className="border border-black px-2 py-1 font-bold text-right">
                    Total
                  </td>
                  <td className="border border-black px-2 py-1  font-bold text-right">
                    {new Intl.NumberFormat("id-ID", {
                      style: "currency",
                      currency: "IDR",
                      minimumFractionDigits: 0,
                    }).format(
                      Number(data.total) +
                        Number(data.total2) +
                        Number(data.total3) +
                        Number(data.total4) +
                        Number(data.total5),
                    )}
                  </td>
                </tr>
              )}
              <tr>
                <td className="border border-black px-2 py-1"></td>
                <td className="border border-black px-2 py-1 font-bold ">
                  Sudah DP
                </td>
                <td className="border border-black px-2 py-1 font-bold"></td>
                <td className="border border-black px-2 py-1 font-bold text-right"></td>
              </tr>
              <tr>
                <td className="border border-black px-2 py-1"></td>
                <td className="border border-black px-2 py-1">
                  Tgl DP 1 :{" "}
                  <b>
                    {data.tgl_dp1 === "0000-00-00 00:00:00"
                      ? ""
                      : format(new Date(data.tgl_dp1), "dd MMM yyyy")}
                  </b>
                </td>
                <td className="border border-black px-2 py-1"></td>
                <td className="border border-black px-2 py-1"></td>
              </tr>
              <tr>
                <td className="border border-black px-2 py-1"></td>
                <td className="border border-black px-2 py-1">
                  Nilai DP 1 :{" "}
                  <b>
                    {data.dp1 === "0"
                      ? ""
                      : new Intl.NumberFormat("id-ID", {
                          style: "currency",
                          currency: "IDR",
                          minimumFractionDigits: 0,
                        }).format(data.dp1)}
                  </b>{" "}
                </td>
                <td className="border border-black px-2 py-1"></td>
                <td className="border border-black px-2 py-1"></td>
              </tr>
              <tr>
                <td className="border border-black px-2 py-1"></td>
                <td className="border border-black px-2 py-1">
                  Tgl DP 2 :{" "}
                  <b>
                    {data.tgl_dp2 === "0000-00-00 00:00:00"
                      ? ""
                      : format(new Date(data.tgl_dp2), "dd MMM yyyy")}
                  </b>
                </td>
                <td className="border border-black px-2 py-1"></td>
                <td className="border border-black px-2 py-1"></td>
              </tr>
              <tr>
                <td className="border border-black px-2 py-1"></td>
                <td className="border border-black px-2 py-1">
                  Nilai DP 2 :{" "}
                  <b>
                    {data.dp2 === "0"
                      ? ""
                      : new Intl.NumberFormat("id-ID", {
                          style: "currency",
                          currency: "IDR",
                          minimumFractionDigits: 0,
                        }).format(data.dp2)}{" "}
                  </b>
                </td>
                <td className="border border-black px-2 py-1"></td>
                <td className="border border-black px-2 py-1"></td>
              </tr>
              <tr>
                <td className="border border-black px-2 py-1"></td>
                <td className="border border-black px-2 py-1">
                  Kekurangan Uang Muka yang harus di transfer dari
                  Perusahaan:{" "}
                </td>
                <td className="border border-black px-2 py-1"></td>
                <td className="border border-black px-2 py-1"></td>
              </tr>
              <tr>
                <td className="border border-black px-2 py-1"></td>
                <td className="border border-black px-2 py-1">
                  Kelebihan uang muka yang harus dikembalikan ke
                  perusahaan:{" "}
                </td>
                <td className="border border-black px-2 py-1"></td>
                <td className="border border-black px-2 py-1"></td>
              </tr>
            </tbody>
          </table>
          <div className="flex flex-row items-right text-xs">
            <div className="w-1/4"></div>
            <div className="w-1/4"></div>
            <div className="w-2/4 flex flex-row">
              <div className="w-1/2 text-right">Tanggal Input:</div>
              <div className="w-1/2 text-center">Tanggal Trf:</div>
            </div>
          </div>

          <div className="text-xs">
            Note:
            <br />
            1. Pengajuan harus sudah di approve sesuai ketentuan
            <br />
            2. Invoice asli/ penawaran harus dilampirkan dengan lengkap <br />
          </div>
          <div className="flex flex-row text-xs mt-4 gap-4">
            <div className="w-full md:w-1/3">
              Diajukan oleh:
              <br />
              <br />
              <br />
              <br />
              <br />
              {data.pic} - approval by wa
              <br />
              Lampirkan Approval by ss WA/ttd dan Nama
            </div>
            <div className="w-full md:w-1/3">
              Approval 1:
              <br />
              <br />
              <br />
              <br />
              <br />
              {data.approval_1} - approval by wa
              <br />
              Lampirkan Approval by ss WA/ttd dan Nama
            </div>
            <div className="w-full md:w-1/3">
              Approval 2:
              <br />
              <br />
              <br />
              <br />
              <br />
              {data.approval_2} - approval by wa
              <br />
              Lampirkan Approval by ss WA/ttd dan Nama
            </div>
          </div>

          <div className="flex print-break justify-items-center items-center flex-row flex-wrap -mx-2 mt-4">
            {Array.isArray(invoiceimg) && (
              <>
                {/* Render semua image terlebih dahulu */}
                {chunkArray(
                  invoiceimg.filter((a) =>
                    ["jpg", "jpeg", "png", "webp"].includes(
                      a.name.split(".").pop().toLowerCase(),
                    ),
                  ),
                  4, // <-- 4 gambar per halaman
                ).map((page, pageIdx) => (
                  <div
                    key={pageIdx}
                    className="print-page grid grid-cols-2 gap-2" // 2 kolom
                  >
                    {page.map((a, idx) => (
                      <div
                        key={idx}
                        className="p-2 flex  items-center justify-center"
                        onClick={() =>
                          setSelectedImage(
                            `${process.env.REACT_APP_BASE_URL}/uploads/img/${a.name}`,
                          )
                        }
                      >
                        <img
                          className="object-contain max-h-[450px]"
                          src={`${process.env.REACT_APP_BASE_URL}/uploads/img/${a.name}`}
                          alt="Uploaded file"
                        />
                      </div>
                    ))}
                  </div>
                ))}
                {selectedImage && (
                  <div
                    className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50"
                    onClick={() => setSelectedImage(null)} // klik background tutup modal
                  >
                    <div className="relative">
                      <img
                        src={selectedImage}
                        alt="Full size"
                        className="max-h-[90vh] max-w-[90vw] object-contain rounded-lg shadow-lg"
                      />
                      <button
                        onClick={() => setSelectedImage(null)}
                        className="absolute top-2 right-2 bg-white text-black px-3 py-1 rounded"
                      >
                        ✕
                      </button>
                    </div>
                  </div>
                )}

                {/* Render semua PDF setelah image */}
                {invoiceimg
                  .filter(
                    (a) => a.name.split(".").pop().toLowerCase() === "pdf",
                  )
                  .map((a, idx) => {
                    let viewerParam = "";

                    // Deteksi browser
                    if (navigator.userAgent.includes("Firefox")) {
                      viewerParam = ""; // Firefox sudah bagus, pakai page-width
                    } else {
                      viewerParam = ""; // Chrome/Opera/Edge butuh FitH agar full
                    }

                    return (
                      <div
                        className="no-print w-full px-2 mb-4 mt-4"
                        key={`pdf-${idx}`}
                      >
                        <div className="rounded shadow">
                          <a
                            className="text-blue-800"
                            href={`${process.env.REACT_APP_BASE_URL}/uploads/img/${a.name}${viewerParam}`}
                          >
                            Download original file
                          </a>
                          <iframe
                            src={`${process.env.REACT_APP_BASE_URL}/uploads/img/${a.name}${viewerParam}`}
                            className="w-full h-[900px]"
                            style={{ border: "none" }}
                            title={`pdf-${idx}`}
                          />
                        </div>
                      </div>
                    );
                  })}
              </>
            )}
          </div>
        </div>
        {user?.group_id === "1" && (
          <>
            <h1 className="text-xs text-gray-500">
              *Ajuan ini diprint oleh:{" "}
              <code className="font-bold">{data.printed_by}</code>
              {data.date_of_printed
                ? `, pada ${new Date(data.date_of_printed)
                    .toLocaleString("id-ID", {
                      day: "numeric",
                      month: "long",
                      year: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: false,
                      timeZone: "Asia/Jakarta",
                    })
                    .replace(/\./g, ":")} WIB`
                : ""}
            </h1>

            {(data?.user_update || data?.update_date) && (
              <h1 className="text-xs text-gray-500">
                *Telah diupdate oleh:{" "}
                {data?.user_update && (
                  <code className="font-bold">{data.user_update}</code>
                )}
                {data?.update_date && (
                  <>
                    {data?.user_update ? "," : ""}
                    {" pada "}
                    {new Date(data.update_date)
                      .toLocaleString("id-ID", {
                        day: "numeric",
                        month: "long",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: false,
                        timeZone: "Asia/Jakarta",
                      })
                      .replace(/\./g, ":")}{" "}
                    WIB
                  </>
                )}
              </h1>
            )}
          </>
        )}
        {data?.trf === "1" && (
          <h1 className="text-xs text-gray-500">
            sudah ditransfer oleh:{" "}
            <code className="font-bold">{data.trf_by}</code>
            {data.date_of_printed
              ? `, pada ${new Date(data.date_of_trf)
                  .toLocaleString("id-ID", {
                    day: "numeric",
                    month: "long",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: false,
                    timeZone: "Asia/Jakarta",
                  })
                  .replace(/\./g, ":")} WIB`
              : ""}
          </h1>
        )}
      </div>
    </div>
  );
};

export default RFDetail;
